module.exports = __webpack_public_path__ + "media/images/glyphicons-halflings-green-hover-3a4d32e981d8d7eac1aa6b96e60bca43.png";